import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Source, Layer } from 'react-map-gl/maplibre'
import { getBookmarkSources, getBookmarkCount } from 'ducks/bookmarks'
import { fetchSlimFollows, buildFollowsPointFeatures } from '../mapUtilities'
import mapSettings from '../mapSettings'

const maxZoom = mapSettings.rasterMaxZoom

const pinLayerStyle = {
  id:     mapSettings.bookmarkPins,
  type:   'circle',
  filter: ['!', ['has', 'point_count']],
  paint:  {
      'circle-color':        '#ccaed0', // $lilacs['key'] from mixins.scss
      'circle-radius':       10,
      'circle-stroke-width': 1,
      'circle-stroke-color': '#000000',
  },
  maxzoom: maxZoom,
}

const clusterLayerStyle = {
  id:     mapSettings.bookmarkClusters,
  type:   'circle',
  filter: ['has', 'point_count'],
  paint:  {
    'circle-color':        '#ccaed0', // $lilacs['key'] from mixins.scss
    'circle-stroke-width': 1,
    'circle-stroke-color': '#000000',
    'circle-radius':       [
        'step',
        ['get', 'point_count'],
        15, // Radius for clusters with less than 10 points
        10,
        20, // Radius for clusters with 10 to 49 points
        50,
        30  // Radius for clusters with 50 or more points
    ]
  },
  maxzoom: maxZoom,
}

const clusterCountLayerStyle = {
  id:     mapSettings.bookmarkClusterCount,
  type:   'symbol',
  filter: ['has', 'point_count'],
  layout: {
    'text-field':  '{point_count_abbreviated}',
    'text-font':   ['Arial Unicode MS Bold'],
    'text-size':   14,
  },
  maxzoom: maxZoom,
}

const SourcePinsLayer = () => {
  const [slimFollows, setSlimFollows] = useState(null)
  const bookmarkSources = useSelector(getBookmarkSources)
  const bookmarkCount = useSelector(getBookmarkCount)

  useEffect(() => {
    let isMounted = true
    async function fetchData() {
      if(!bookmarkCount && isMounted) {
        setSlimFollows(null)
        return
      }
      try {
        const data = await fetchSlimFollows()
        if(isMounted) setSlimFollows(data)
      } catch (error) {
        if(isMounted) debug('Error fetching slim follows:', error)
      }
    }
    fetchData()
    return () => { isMounted = false }
  }, [bookmarkCount]) // Re-fetch when bookmarkCount changes (e.g. add/remove)

  const featuresArray = slimFollows ? buildFollowsPointFeatures(slimFollows, bookmarkSources) : []

  // Don't render if no bookmark features
  if(featuresArray.length === 0) {
    return null
  }

  // Create a GeoJSON source for the pins
  const geojsonData = {
    type:     'FeatureCollection',
    features: featuresArray
  }

  return (
    <Source
      id={mapSettings.bookmarkPinsSource}
      type="geojson"
      data={geojsonData}
      cluster={true}
      clusterRadius={50}
    >
      <Layer {...clusterLayerStyle} />
      <Layer {...clusterCountLayerStyle} />
      <Layer {...pinLayerStyle} />
    </Source>
  )
}

export default SourcePinsLayer